const kk = {
  nav: {
    home: 'Басты бет',
    about: 'Біз туралы',
    disciplines: 'Бағыттар',
    goals: 'Мақсаттар',
    events: 'Іс-шаралар',
    documents: 'Құжаттама',
    docs_patriot: '«Patriot» құжаттамасы',
    contacts: 'Байланыс',
    admin: 'Администрация',
    title: 'Ұлттық Федерация',
    subtitle: 'әскери-қолданбалы спорт түрлері бойынша',
  },
  hero: {
    label: 'Ұлттық Федерация',
    title: 'Жауынгер жолы',
    subtitle: '«Әскери-қолданбалы спорт түрлері бойынша Ұлттық Федерациясы» Қоғамдық Бірлестігі',
    btn_about: 'Федерация туралы',
    btn_events: 'Іс-шаралар',
  },
  stats: {
    athletes: 'Спортшылар',
    regions: 'Өңірлер',
    events: 'Жылдық іс-шаралар',
    ranks: 'Спорттық разрядтар',
  },
  about: {
    title: 'Федерация туралы',
    subtitle: 'Ұлттық Федерация',
    desc: '«Әскери-қолданбалы спорт түрлері бойынша Ұлттық Федерациясы» Қоғамдық Бірлестігі елдің үздік атлеттерін біріктіреді, дене шынықтыру мен жауынгерлік дайындықты дамытады.',
  },
  disciplines: {
    title: 'Спорт бағыттары',
  },
  goals: {
    title: 'Біздің мақсаттарымыз',
  },
  quote: {
    title: 'Мұнда күш, мінез бен абырой туады.',
    text: 'Әскери-қолданбалы спорт түрлері — шеберлікке, жауапкершілікке және Отанға қызмет етуге апаратын жол.',
  },
  events: {
    title: 'Алдағы іс-шаралар',
  },
  footer: {
    rights: 'Барлық құқықтар қорғалған.',
    contacts: 'Байланыс ақпараты',
  },
  admin: {
    title: 'Сайт мәтіндері',
    save: 'Сақтау',
    saved: 'Сақталды',
    lang_kk: 'Қазақша',
    lang_ru: 'Русский',
    lang_en: 'English',
  },
};

export default kk;
